import { makeStyles } from '@mui/styles';
const discountsStyles = makeStyles(() => ({
    headerTitle: {
        fontWeight: 'bold',
    },
    label: {
        lineHeight: '24px',
    },
    price: {},
    content: {
        width: '100%',
    },
    discountPrice: {
        fontWeight: 'bold',
        marginRight: 32,
    },
    priceSign: {
        display: 'inline-block',
    },
}), { name: 'Common_Discounts' });
export default discountsStyles;
//# sourceMappingURL=discounts.styles.js.map